import { all } from 'redux-saga/effects'
import { authSagas } from './features/auth'
import { articleSagas } from './features/articles'
import { revisionSagas } from './features/revisions'
import { settingsSagas } from './features/settings'
import { routerSagas } from './features/router'
import { socketSagas } from './features/socket'

export default function* sagas() {
	yield all([
		...routerSagas,
		...authSagas,
		...articleSagas,
		...revisionSagas,
		...settingsSagas,
		...socketSagas,
	])
}
